import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            精彩预告
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            最新影视前瞻与深度解析，提前锁定不容错过的好片
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-white text-3xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-black/70 rounded-md">
                  <span className="text-white text-xs font-medium">{item.duration}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}